'use strict';/*
*	GDPR
*/jQuery(document).ready(function(){if($('#gdpr').length){if(Cookies.get('ikocontact')==null){setTimeout(function(){$('#gdpr').show();},5000);$('#gdpr-accept').click(function(){Cookies.set('ikocontact','accept',{expires:30,path:'/'});$('#gdpr').hide();});}}});